export const setupAPIM = (APIM_KEY: string) => {
  if (!APIM_KEY) {
    if (!import.meta.env.DEV) {
      throw new Error('APIM key is not set');
    }
    return;
  }

  const apimBaseUrl = import.meta.env.VITE_APIM_URL;

  if (!apimBaseUrl) {
    throw new Error('APIM base URL is not set');
  }

  function rewriteUrl(url: string) {
    // CERC API
    if (url.includes('/getexposure')) {
      let urlObj: URL;
      try {
        urlObj = new URL(url);
      } catch {
        urlObj = new URL(url, window.location.origin);
      }
      const queryParams = urlObj.search;
      const newUrl = `${apimBaseUrl}/route/planner/v1/clean-air/exposure/retrieve${queryParams}`;
      return newUrl;
    }

    return url;
  }

  function isApimUrl(url: string) {
    try {
      const urlObj = new URL(url);
      const apimHostname = new URL(apimBaseUrl).hostname;
      return urlObj.hostname === apimHostname;
    } catch {
      return false; // Return false if the URL is invalid
    }
  }

  // Fetch interceptor
  const originalFetch = window.fetch;
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
    const originalUrl = typeof input === 'string' ? input : (input as Request).url;
    const newUrl = rewriteUrl(originalUrl);

    if (newUrl !== originalUrl) {
      if (typeof input === 'string') {
        input = newUrl;
      } else {
        const request = input as Request;
        input = new Request(newUrl, {
          method: request.method,
          headers: request.headers,
          body: request.body,
          mode: request.mode,
          credentials: request.credentials,
          cache: request.cache,
          redirect: request.redirect,
          referrer: request.referrer,
          integrity: request.integrity,
        });
      }
    }

    if (isApimUrl(newUrl)) {
      init = init || {};
      init.headers = init.headers || {};
      const headers = init.headers as Record<string, string>;

      headers['Ocp-Apim-Subscription-Key'] = APIM_KEY;
    }

    return originalFetch(input, init);
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method: string, url: string) {
    const newUrl = rewriteUrl(url);
    (this as XMLHttpRequest & { _url?: string })._url = newUrl;
    return originalXHROpen.call(this, method, newUrl, true);
  };

  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body?: Document | XMLHttpRequestBodyInit | null) {
    const url = (this as XMLHttpRequest & { _url?: string })._url;
    if (url && isApimUrl(url)) {
      this.setRequestHeader('Ocp-Apim-Subscription-Key', APIM_KEY);
    }
    return originalXHRSend.call(this, body);
  };
};
